<template>
	<div id="n_help">
		<title>鸿利智能</title>
		<div class="i-background">
			<div>
				<img src="/static/img/help@2x1022.png"/>
				<div>
					<p>此设备类型：{{help.name}}</p>
					<p>设备SN编号：</p>
					<div style="height:18px;"></div>
					<mt-field v-if="help.sn" disabled type="text" placeholder="请输入设备SN或FN编号" v-model="help.sn"></mt-field>
					<div style="height:30px;"></div>
					<div class="button">
						<mt-button @click.native="go('download')" type="default">
							<p>APP下载</p>
							<p>APP Download</p>	
						</mt-button>
						<mt-button @click.native="go('editor',help.name=='Z11'?{editorValue:'help'}:{editorValue:help.name})" type="default">
							<p>使用说明</p>
							<p>instructions</p>
						</mt-button>
					</div>
					<!-- <div class="button">
						<mt-button @click.native="go('issue',$route.params)" type="default">意见反馈</mt-button>
						<mt-button @click.native="go('wxprior')" type="default">在线预约</mt-button>
					</div> -->
					<!--<div class="button">
						<mt-button @click.native="prior" type="default">自助保修</mt-button>
					</div>-->
					<div style="text-align: center;position:absolute;bottom: 24px;left:0;width: 100vw;color:#FFF">
						<p>官方客服电话：400-999-8976</p>
						<p>版权归浙江鸿利锁业有限公司所有</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { Field,Button,Toast } from 'mint-ui';
	export default {
		computed: {
			
		},
		data() {
			return {
				help:{},
				dev_fn:''
			}
		},
		methods: {
			go(v,d={}){
				this.$router.push({ name:v,params:d});
			},
			prior() {
				this.$store.dispatch('post',{u:'/custom_service_record/app_add',d:this.form}).then(function(res){
			    	if(res.err==0){
			    		Toast({
							message: '提交成功，请耐心等待！',
							iconClass: 'iconfont icon-gou'
						});
						return
			    	}
			    	Toast({
						message: res.data,
					});
				})
			},
		},
		mounted() {
			let self=this
			self.dev_fn=self.$route.params.fnsn
			self.$store.dispatch('post',{u:'/dev/get',d:{fn:self.$route.params.fnsn}}).then(function(res){
		    	if(res.err==0){
		    		self.help=res.data
					return
		    	}
		    	Toast({
					message: res.data,
				});
			})
		}
	}
</script>
<style scoped>
	.button{
		margin-bottom: 5%;
	}
	.button button{
		width:45%;
		color:#fff;
		background:#F6A400;
	}
	.button button:first-of-type{
		margin-right:8%;
	}
	
</style>
<style>
	#n_help .mint-button{
		height:80px !important; 
	}	
	#n_help .mint-button--normal{
		padding:0px 0px !important; 
	}
</style>


// WEBPACK FOOTER //
// src/views/help.vue